export default {
  // 搜索区
  templateName: '模板名称',
  templateNamePlaceholder: '请输入模板名称',
  productName: '产品名称',
  productNamePlaceholder: '请输入产品名称',
  // 表格列
  colTemplateName: '模板名称',
  colRelatedProduct: '关联产品',
  colIsDefault: '默认模板',
  // 默认模板
  defaultOn: '开启',
  defaultOff: '关闭',
  defaultOnSuccess: '已设为默认模板',
  defaultOffSuccess: '已关闭默认模板',
  defaultChangeFailed: '默认模板状态更新失败',
  // 操作
  editTemplate: '修改模板',
  addProduct: '添加产品',
  // 添加产品弹窗
  addProductTitle: '添加关联产品',
  selectProduct: '选择产品',
  selectProductPlaceholder: '请选择产品',
  productRequired: '请选择产品',
  addProductSuccess: '产品添加成功',
  addProductFailed: '产品添加失败',
  // 删除产品
  deleteProductSuccess: '产品删除成功',
  deleteProductFailed: '产品删除失败',
  // 修改模板
  editTemplateSuccess: '模板修改成功',
  editTemplateFailed: '模板修改失败',
  // 查看产品弹窗
  viewProductsTitle: '关联产品列表',
  colProductId: '产品ID',
  colProductName: '产品名称',
  // 空状态
  emptyText: '暂无模板数据',
};
